import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button,ButtonGroup,Divider, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box, InputAdornment, Switch, Stepper, Step, StepLabel, Avatar, Autocomplete } from "@mui/material";
// components
import Page from "src/components/Page";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import NavBack from "src/components/common/NavBack";
import { getAreas, getMerchantCategories } from "src/services/request";
import AddressPicker from "src/components/common/AddressPicker";
import { asyncRequest } from "src/services/network";
import Cascader from "src/components/cascader/Cascader";
import FormDialogTwo from "src/components/common/FormDialogTwo";
import SectionHeader from "src/components/section-header/SectionHeader";
import MyDatePicker from "src/components/MyDatePicker";
import dayjs from "dayjs";
// import banks from "src/data/banks.json";
import UserInfo from "src/components/common/UserInfo";
import TiejunPicker from "src/components/common/TiejunPicker";
import UserPicker from "src/components/common/UserPicker";
import BankPicker from "src/components/common/BankPicker";
import MccPicker from "src/components/common/MccPicker";
import StoreIcon from "@mui/icons-material/Store";
import { LoadingButton } from "@mui/lab";

const steps = ["基础信息", "业务信息", "确认提交"];

// const bizTypes = ['餐饮', '电商平台', '零售', '食品生鲜', '咨询/娱乐票务', '房产中介', '宠物医院', '共享服务', '休闲娱乐/旅游服务', '游艺厅/KTV', '网吧', '院线影城', '演出赛事', '居民生活服务', '景区/酒店', '铁路客运', '机票/票务代理', '培训机构', '保健器械/医疗器械/非处方药品', '其他私立/民营医院/诊所', '其他缴费', '停车缴费', '私立/民营口腔及眼科、医疗美容医院/诊所']

export default function MerchantEdit({ item, onClose,onBtnFun,onrefreshKF, onFinish, isApply }) {
  const { merchantCategories, areas, areaHierarchy, areaMap } = useSelector((state) => state.globalData);

  const navigate = useNavigate();
  const { mid } = item;
  const [category, setCategory] = useState({});
  const [detailObj, setdetailObj] = useState(item);
  const [address, setAddress] = useState({
    address: item.address,
  });

  const [area, setArea] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [parent, setParent] = useState(item.parent || {});
  const [agent, setAgent] = useState(item.agent || {});
  const [form, setForm] = useState({
    mid: 0,
    platformCode: item.platformCode || 'huifu',
    businessRole:item.businessRole || 'ACQUIRING',
    type: item.type || 0,
    mobile: item.mobile || "",
    name: item.name || "",
    logo: item.logo || "",
    entrancePic: item.entrancePic || "",
    images: item.images || "",
    username: item.username || "",
    password: item.password || "",
    realname: item.realname || "",
    license: item.license || "",
    intro: item.intro || "",
    // 地理信息
    province: item.province || "",
    city: item.city || "",
    district: item.district || "",
    address: item.address || "",
    isZhiyin: item.isZhiyin || false,
    lng: item.lng || "",
    lat: item.lat || "",

    idCardNoSettle: item.idCardNoSettle || "",
    cardImgFrontSettle: item.cardImgFrontSettle || "",
    cardImgBackSettle: item.cardImgBackSettle || "",
    authEnturstPic: item.authEnturstPic || "",
    mobileSettle: item.mobileSettle || "",

    // 新增
    cardImgFront: item.cardImgFront || "",
    cardImgBack: item.cardImgBack || "",
    idCardNo: item.idCardNo || "",
    idCardAddress: item.idCardAddress || "",
    idCardStartDate: item.idCardStartDate || "",
    idCardEndDate: item.idCardEndDate || "",
    idCardEndDateLong: item.idCardEndDate == "长期" || false,
    licenseStartDate: item.licenseStartDate || "",
    licenseEndDate: item.licenseEndDate || "",
    licenseEndDateLong: item.licenseEndDate == "长期" || false,
    licenseNo: item.licenseNo || "",
    licenseRange: item.licenseRange || "",
    accountName: item.accountName || "",
    accountNumber: item.accountNumber || "",
    accountBank: item.accountBank || "",
    accountBankName: item.accountBankName || "",
    bankDistrictId: item.bankDistrictId || "",
    bankcard: item.bankcard || "",
    email: item.email || "",
    licenseName: item.licenseName || "",
    qualificationType: item.qualificationType || "",

    hfUid: item.hfUid || "",
    provinceId: item.provinceId || null,
    cityId: item.cityId || null,
    districtId: item.districtId || null,

    status: item.status || 1,
    order: item.order || 0,
    rangli: item.rangli || 20,
    discount: item.discount || 10,

    pid: item.pid || null,
    quUid: item.quUid || null,
    cardType: item.cardType != undefined ? item.cardType : 1,
  });
  // 添加倒计时状态
  const [countdown, setCountdown] = useState(0);
  const [countdownTwo, setCountdownTwo] = useState(0);
  const [isCounting, setIsCounting] = useState(false);
  const [isCountingTwo, setIsCountingTwo] = useState(false);
  // 倒计时效果
  useEffect(() => {
    let timer;
    if (isCounting && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsCounting(false);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isCounting, countdown]);
  useEffect(() => {
    let timer;
    if (isCountingTwo && countdownTwo > 0) {
      timer = setTimeout(() => {
        setCountdownTwo(countdownTwo - 1);
      }, 1000);
    } else if (countdownTwo === 0) {
      setIsCountingTwo(false);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isCountingTwo, countdownTwo]);
  useEffect(() => {
    // getAreas();
    // getMerchantCategories();
    // checkPlatform()
    // console.log(1111)
    // console.log(item)
  }, []);
  useEffect(() => {
    if (!merchantCategories.length || !item.categoryId) return;

    setCategory(merchantCategories.find((it) => it.id == item.categoryId) || {});
  }, [merchantCategories]);

  useEffect(() => {
    if (!areas) return;
    if (!form.provinceId) return;
    const province = areas.find((area) => area.id === form.provinceId);
    const city = areas.find((area) => area.id === form.cityId);
    const qu = areas.find((area) => area.id === form.districtId);
    // setArea(`${province.name}${city.name}${qu.name}`);
  }, [areas, form.districtId]);

  function handleIptChange(ki, val) {
    if(ki=='platformCode'){
      checkPlatform()
    }
    setForm({
      ...form,
      [ki]: val,
    });
  }
  const moreMenus = [
    // {title: "开通三方支付"},
    // {title: "开通业务"},
    // {title: "微信实名认证"},
    // {title: "支付宝实名认证"},
    {title: "同步开户信息"},
    {title: "重新入驻"},
    {title: "添加微信特约商户appid"},

  ];
  function checkPlatform() {
    if(form.platformCode =='qdkf'){
      return true
    }else{
      return false
    }
  }
  function handleSelectBank() {
    BankPicker({
      onSelect(val) {
        handleIptChange("accountBank", val.name);
      },
    });
  }

  function handleSelectMcc() {
    MccPicker({
      onSelect(val) {
        handleIptChange("qualificationType", val.name);
      },
    });
  }
  function rangliFun() {
    let rangli = 0
    rangli = detailObj.rangli?detailObj.rangli:0
    return <Typography variant="body2">让利：{rangli}%</Typography>
  }
  function stateFun() {
     let state=''
     // 定义每个状态对应的样式
    const statusStyles = {
      class99: {
        backgroundColor: '#ff4a00',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#ff4a00',
          color: '#fff',
        }
      },
      class0: {
        backgroundColor: '#ccc',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#ccc',
          color: '#fff',
        }
      },
      class1: {
        backgroundColor: '#fb9d6f',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#fb9d6f',
          color: '#fff',
        }
      },
      class2: {
        backgroundColor: '#29e1b3',
        color: '#fff',
        '&:hover':{
          backgroundColor: '#29e1b3',
          color: '#fff',
        }
      },
      class3: {
        backgroundColor: '#009fe8',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#009fe8',
          color: '#fff',
        }
      },
      class9: {
        backgroundColor: '#01d463',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#01d463',
          color: '#fff',
        }
      },
    };
    let objName=''
    objName = 'class'+detailObj.kfShowStatus
    if(detailObj.kfShowStatus==1||detailObj.kfShowStatus==99){
      state='快付审核中'
    }else if(detailObj.kfShowStatus==2||detailObj.kfShowStatus==3){
      state='快付待签约'
    }else if(detailObj.kfShowStatus==9){
      state='快付已完成'
    }else {
      state='快付未开通'
    }

    return (
      <Button
        variant="contained"
        size="small"
        sx={statusStyles[objName] || {}}  // 使用 sx 属性动态应用样式
        >
        {state}
      </Button>
    )
  }
  function urlFun() {
    return detailObj && detailObj.kfApp && detailObj.kfApp.registerUrl ? detailObj.kfApp.registerUrl : '';
  }
  async function onApplyHuifu() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/merchant/gdkf/register/query/"+mid,
    });
    rangliFun()
    stateFun()
    urlFun()
  }
  async function onApplyKF() {
    // 如果正在倒计时，直接返回
    if (isCounting) return;

    // 开始倒计时
    setCountdown(60);
    setIsCounting(true);

    try {
      const { data } = await asyncRequest({
        path: "/merchant/updateByKf",
        data: {
          mid: mid
        }
      });

      // 合并现有状态和新数据，保留原有字段
      setdetailObj(prevState => ({
        ...prevState,
        ...data
      }));

      // 可选：显示成功消息
      // alert("同步开户信息成功", "success");

    } catch (error) {
      console.error("同步开户信息失败:", error);
      // alert("同步开户信息失败，请重试", "error");
    }
  }
  async function onApplyCheckKF() {
    // 如果正在倒计时，直接返回
    if (isCountingTwo) return;

    // 开始倒计时
    setCountdownTwo(60);
    setIsCountingTwo(true);
  }
  async function handleMenuClick(type) {
    // 如果是同步开户信息，调用专门的函数
    if (type === "同步开户信息") {
      await onApplyKF();
      await onrefreshKF();
    }else if (type === "查询开户认证") {
      onApplyHuifu()
      await onApplyCheckKF();
    } else {
      onBtnFun(type, detailObj);
    }
  }
  return (
    <FormDialogTwo open onClose={onClose} title='快付商户配置'>
      <Box sx={{ width: 1000 }}>
        {(form.type == 0 || form.type == 1) && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <SectionHeader title="商户信息" sx={{paddingBottom:2}}/>
            <Stack sx={{ minWidth: 600 }}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography variant="body2">商户名：{item.name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  {rangliFun()}
                  {/* <Typography variant="body2">让利：{item.rangli}%</Typography> */}
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">开户进度：{stateFun()}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    开户地址：
                  <span style={{ color: '#009fe8', cursor: 'pointer' }}
                        onClick={() => {
                          const url = urlFun();
                          if (url) window.open(url, '_blank');
                        }}>
                    {urlFun() || '暂无'}
                  </span>
                  </Typography>
                </Grid>
                {(item.kfShowStatus == 2) && (
                <Grid item xs={12}>
                  <Stack sx={{ fontSize: "12px", color: "#666" }}>
                    请法人或商户管理员注意查收签约短信，点击或复制签约链接至浏览器，进行支付宝或者微信签约
                  </Stack>
                </Grid>
                )}
                {(item.kfShowStatus == 3) && (
                <Grid item xs={12}>
                  <Typography variant="body2">
                    签约状态：签约成功
                  </Typography>
                </Grid>
                )}
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <LoadingButton
                      loadingPosition="start"
                      variant="outlined"
                      // onClick={onApplyHuifu}
                      onClick={() => handleMenuClick('查询开户认证')}
                      disabled={isCountingTwo}
                      sx={{ marginLeft: 1 }}
                    >
                      {isCountingTwo ? `查询开户认证(${countdownTwo}s)` : '查询开户认证'}
                    </LoadingButton>
                  </Typography>
                </Grid>
                {(item.kfShowStatus == 3||item.kfShowStatus == 9) && (
                  <>
                  <Grid container>
                    <Grid item xs={6} sx={{ marginTop: 5 }}>
                      <Typography variant="body2">
                        <Button
                          loadingPosition="start"
                          variant="outlined"
                        >
                          微信开户意愿认证
                        </Button>
                      </Typography>
                      <Stack sx={{ marginTop: 2 }}>商户确认状态：{item.kfApp.wxDesc}</Stack>
                      <Stack sx={{ marginTop: 1 }}>微信商户号：{ item.kfApp.wxMerCode }</Stack>
                      <Stack sx={{ marginTop: 1 }}>微信授权码：</Stack>
                      {(item.kfApp.wxQrUrl)&& (
                        <Box sx={{  marginTop: 1,display: 'block', width:'300px', height:'300px',textAlign: 'center' }}>
                          {/* <img src={'https://oss.xunyetech.xyz'+item.parent.avatar}/> */}
                          <img src={item.kfApp.wxQrUrl}/>
                        </Box>
                      )}
                      {/* <Box sx={{ display: 'block', width:'300px', height:'300px',margin: '0 auto', textAlign: 'center' }}> */}
                       {/* <Box sx={{  marginTop: 1,display: 'block', width:'300px', height:'300px',textAlign: 'center' }}>
                        <img src={'https://oss.xunyetech.xyz'+item.parent.avatar}/>
                      </Box> */}
                    </Grid>
                    <Grid item xs={6} sx={{ marginTop: 5 }}>
                      <Typography variant="body2">
                        <LoadingButton
                          loadingPosition="start"
                          variant="outlined"
                        >
                          支付宝实名认证
                        </LoadingButton>
                      </Typography>
                      <Stack sx={{ marginTop: 2 }}>商户确认状态：{item.kfApp.alipayDesc}</Stack>
                      <Stack sx={{ marginTop: 1 }}>微信商户号：{ item.kfApp.alipayMerCode }</Stack>
                      {(item.kfApp.alipayQrUrl)&& (
                        <>
                        <Stack sx={{ marginTop: 1 }}>支付宝授权码：</Stack>
                        <Box sx={{  marginTop: 1,display: 'block', width:'300px', height:'300px',textAlign: 'center' }}>
                          <img src={item.kfApp.alipayQrUrl}/>
                        </Box>
                        </>
                      )}
                      {/* <Box sx={{ display: 'block', width:'300px', height:'300px',margin: '0 auto', textAlign: 'center' }}> */}
                       {/* <Box sx={{  marginTop: 1,display: 'block', width:'300px', height:'300px',textAlign: 'center' }}>
                        <img src={'https://oss.xunyetech.xyz'+item.parent.avatar}/>
                      </Box> */}
                    </Grid>
                  </Grid>
                  </>
                )}
              </Grid>
            </Stack>
            <Divider sx={{ marginY: 2 }} />
            <Grid container spacing={1}>
              <Stack direction="row" sx={{ marginTop: 2,marginBottom:1 }}>
                <ButtonGroup variant="outlined" aria-label="outlined button group">
                  {moreMenus.map((menu, i) => {
                    const { title, icon } = menu;
                    // 如果是同步开户信息按钮，添加倒计时状态
                    if (title === "同步开户信息") {
                      return (
                        <Button
                          key={i}
                          onClick={() => handleMenuClick(title)}
                          disabled={isCounting}
                        >
                          {isCounting ? `同步开户信息(${countdown}s)` : title}
                        </Button>
                      );
                    }
                    return (
                      <Button key={i} onClick={() => handleMenuClick(title)}>
                        {title}
                      </Button>
                    );
                  })}
                </ButtonGroup>
              </Stack>
            </Grid>
          </Paper>
        )}
        {/* {!mid && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <SectionHeader title="管理员信息" />

            <Grid container>
              <Grid item md={6}>
                <FormItem title="登陆账号" required>
                  <TextField fullWidth placeholder="登陆账号" autoComplete="off" id="username" value={form.username} size="small" onChange={(e) => handleIptChange("username", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="登录密码" required>
                  <TextField fullWidth placeholder="登录密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
                </FormItem>
              </Grid>
            </Grid>
          </Paper>
        )} */}
      </Box>
    </FormDialogTwo>
  );
}